import { render, staticRenderFns } from "./weightEditDialog.vue?vue&type=template&id=3239050e&"
import script from "./weightEditDialog.vue?vue&type=script&lang=ts&"
export * from "./weightEditDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports